import * as Sentry from "@sentry/react";

export const processUnexpectedError = (error: Error) => {
  console.log("> processUnexpectedError: ", error);

  Sentry.captureException(error);

  throw error;
};
